import { jsx } from "react/jsx-runtime";
import { Text } from "@nxt-costco-com/forge-components";
import { getFormattedPrice } from "../../../../../../ProductTile/ProductTileUI/CardBody/PriceGroup/Price/lib.js";
import { instantSavingsStyles } from "./styles.js";
const InstantSavings = ({
  displayDiscount,
  instantSavingsText,
  locale,
  partNumber,
  promoText,
  totalDiscount
}) => {
  if (promoText || !displayDiscount || !instantSavingsText || !totalDiscount || totalDiscount <= 0)
    return null;
  const formattedPrice = getFormattedPrice(locale, totalDiscount, true);
  return /* @__PURE__ */ jsx(
    Text,
    {
      sx: instantSavingsStyles,
      uniqueId: `instantSavings_${partNumber}`,
      variant: "t6",
      children: `${formattedPrice} ${instantSavingsText}`
    }
  );
};
export {
  InstantSavings
};
